module.exports = __webpack_public_path__ + "static/media/img-product-point.a7089ebb.svg";